<template>
    <div>
        <div class="mb-md-5" v-for="(attribute, index) in attributes" :key="index">
            <h4 class="mt-0 pt-3 filter-subtitle">{{attribute.name}}</h4>
            <hr class="sidebar-categories-spacer">
            <div class="form-check mb-3" v-for="(item, attr_index) in attribute.values" :key="attr_index">
                <input class="form-check-input" type="checkbox" :value="item" v-model="filter_attributes[attribute.id]" :id="'filter_attribute' + attribute.id + attr_index" @change="change_filter_attribute($event)">
                <label class="form-check-label" :for="'filter_attribute' + attribute.id + attr_index">
                    {{ item }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'attributes'
    ],
    data: () => ({
        filter_attributes: {}
    }),
    created() {
        for (let i in this.attributes) {
            this.filter_attributes[this.attributes[i]['id']] = []
        }
    },
    mounted() {
        if (this.$route.query.filter_attributes) {
            let attributes = this.filter_attributes
            let query = JSON.parse(this.$route.query.filter_attributes)
            _.merge(attributes, query)
            this.filter_attributes = attributes
            // for (let index in query) {
            //   for (let i in query[index]) {
            //     // this.$set(this.filter_attributes[index], i, query[index][i])
            //     // console.log(index, i, query[index][i])
            //   }
            // }
        }
    },
    methods: {
        change_filter_attribute($event) {
            let query = {};
            for (let i in this.filter_attributes) {
                if (this.filter_attributes[i].length) {
                    query[i] = this.filter_attributes[i];
                }
            }
            if (Object.keys(query).length) {
                this.query({filter_attributes: JSON.stringify(query)}, ['page']);
            } else {
                this.query({}, ['page', 'filter_attributes']);
            }
        }
    }
}
</script>
